import { render } from "./parameterView.vue?vue&type=template&id=ee1ed314"
import script from "./parameterView.vue?vue&type=script&lang=js"
export * from "./parameterView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Programming\\Padmaweb\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__